import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

export const DinamycTable = ({ data = [], columns = [], name = '' }) => {
    // debugger
    return (
        <div
            style={{
                borderRadius: '17px',
                width: '100%',
                marginBottom: '2rem'
            }}
        >
            <h3 style={{ fontSize: '1.5rem', fontWeight: '500', marginBottom: '1rem' }}>{name}</h3>

            {data?.length === 0 ? (
                <div className="message">
                    <h3>{name}</h3>
                    <div style={{ width: '60%', margin: '0 auto', minWidth: '200px' }}>
                        <p>No hay datos disponibles</p>
                    </div>
                </div>
            ) : (
                <div style={{ overflowX: 'auto' }}>
                    <DataTable
                        value={data}
                        stripedRows
                        className="custom-striped-table"
                        style={{
                            borderRadius: '17px',
                            width: '100%',
                            tableLayout: 'fixed',
                            fontSize: '14px',
                            fontWeight: 'normal',
                            textAlign: 'center',
                            borderRadius: '17px'
                        }}
                        scrollable
                        scrollHeight="flex"
                        paginator   
                        rows={5}                 // Número de filas por página
                        rowsPerPageOptions={[5, 10, 20]} // Opciones para cambiar número de filas
                    >
                        {columns.map((col, index) => (
                                <Column style={{ fontSize: '14px', fontWeight: 400, textAlign: 'center' }} key={index} field={col?.field && col.field.trim() !== '' ? col.field : '-'}  header={col.header} />
                        ))}
                    </DataTable>
                </div>
            )}
        </div>
    );
};
